import React, { Dispatch, SetStateAction, useState } from 'react';
import moment from 'moment';

import { Eye, Triangle } from 'lucide-react';

import { ISessionForCDSessions } from '../../../types/services.interface';

interface SessionListItemProps {
    session: ISessionForCDSessions;
    setFeedbackViewData: Dispatch<SetStateAction<{ sessionId: string } | null>>;
    setAnalysisViewData: Dispatch<SetStateAction<{ analysisId: number } | null>>;
    setConversationsViewData: Dispatch<SetStateAction<{ conversationId: string } | null>>;
};
export const SessionListItem = (props: SessionListItemProps) => {
    const { session, setFeedbackViewData, setAnalysisViewData, setConversationsViewData } = props;

    const [sessionOpen, setSessionOpen] = useState(false);

    const onToggleSession = () => {
        setSessionOpen(!sessionOpen);
    };

    return (
        <div className={`card card--sm complete_data__session ${sessionOpen ? 'complete_data__session--open' : ''}`}>
            <button className='complete_data__session__main_btn' onClick={onToggleSession}>
                <p className='text-sm text-medium color--primary'>
                    Created on {moment(session.createdAt).format('MMM DD, YYYY')}
                </p>
                <Triangle />
            </button>
            {sessionOpen && (
                <div className='complete_data__session__details'>
                    <button
                        className='cd-btn cd-btn--md'
                        disabled={!session.feedbacks_v1 && !session.feedbacks_v2}
                        onClick={() => setFeedbackViewData({ sessionId: session.sessionId })}
                    >
                        <span>View Feedbacks</span>
                        <Eye />
                    </button>

                    <div className='complete_data__session__details__scenarios'>
                        {session.simulations.map((simulation) => (
                            <div
                                key={simulation.key}
                                className='complete_data__session__details__scenarios__scenario'
                            >
                                <p className='text-semibold color--primary'>{simulation.title}</p>

                                <div className='complete_data__session__details__scenarios__scenario__conversations'>
                                    <p className='text-sm text-medium color--gray-700'>View Conversation(s):</p>
                                    <ul>
                                        {simulation.stages.map((stage) => (
                                            <li key={stage.key}>
                                                <p className='text-sm color--gray-700'>{stage.person} <span className='color--gray-500'>({stage.title}):</span></p>
                                                {stage.conversation_ids.map((conversationId, idx) => (
                                                    <button
                                                        key={conversationId}
                                                        className='cd-btn cd-btn--sm'
                                                        onClick={() => setConversationsViewData({ conversationId: conversationId })}
                                                    >
                                                        <span>Attempt {idx + 1}</span>
                                                        <Eye />
                                                    </button>
                                                ))}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className='complete_data__session__details__scenarios__scenario__analyses'>
                                    <p className='text-sm text-medium color--gray-700'>View Analysis:</p>
                                    {simulation.analyses_ids.length === 0 && (
                                        <p className='text-sm color--gray-600'>No Analysis Yet!</p>
                                    )}
                                    {simulation.analyses_ids.map((analysisId, idx) => (
                                        <button
                                            key={analysisId}
                                            className='cd-btn cd-btn--sm'
                                            onClick={() => setAnalysisViewData({ analysisId: analysisId })}
                                        >
                                            <span>Attempt {idx + 1}</span>
                                            <Eye />
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
